<script>
import Store from '../../services/lstorage'
import PuzzleChess from './puzzle'
// import Chessground from 'chessground'
import UserService from '../../services/user'
import PuzzleService from '../../services/puzzle'
import Chess from 'chess.js'
import toast from 'vue-material-components'
import Jquery from 'jquery'
import BoardVisorSmall from '../game/boardVisorSmall'
import ClubService from '../../services/club'
import Swal from 'sweetalert2'
import PgnHeaderCard from '../common/PgnHeaderCard.vue'
// import puzzle from '../../services/puzzle'

var groundInit = 1
// var groundFinish = 1
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    },
    data (transition) {
      return Promise.all([
        PuzzleService.count(this)
      ]).then(function (data) {
        const theD = JSON.parse(data)
        // window.alert(JSON.stringify(theD))
        return {
          counts: theD
        }
      }, function (response) {
        // window.alert('no se pudo contar')
      })
    }
  },
  template: require('./template.html'),
  data () {
    return {
      loading: -1,
      listaclubs: [],
      clubActual: '',
      clubActual1: '',
      clubActual2: '',
      user: UserService.getUser(),
      mode: 'add',
      fenInit: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      fenFinish: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      pgn: '',
      startPlay: 0,
      club: '',
      numMoves: 1,
      timeMove: 60,
      tituloFen: 'Ejercicio',
      clubs: UserService.getUser().club,
      myPGNValue: '',
      myFENValue: '',
      pgnFiles: [],
      item: {
        num: 0
      },
      counts: [],
      chess: new Chess(),
      puzzleType: {},
      puzzlesType: [
        {
          numMoves: 1,
          timeMove: 120,
          type: 'Practica0',
          description: 'Practica contra el ordenador',
          position: false
        },
        {
          numMoves: 1,
          timeMove: 120,
          type: 'Practica',
          description: 'Practica contra el ordenador',
          position: false
        },
        {
          numMoves: 1,
          timeMove: 120,
          type: 'Practica1',
          description: 'Practica contra el ordenador',
          position: false
        },
        {
          numMoves: 1,
          timeMove: 120,
          type: 'Practica2',
          description: 'Practica contra el ordenador',
          position: false
        }/* ,
        {
          numMoves: 1,
          timeMove: 120,
          type: 'Practica3',
          description: 'Practica contra el ordenador',
          position: false
        } */
      ],
      puzzles: [],
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      classBoard: '',
      showFenPosition: false
    }
  },
  mixins: [
    toast
  ],
  components: {
    PuzzleChess,
    BoardVisorSmall,
    PgnHeaderCard
  },
  computed: {
    puzzleTypesAvailable () {
      if (this.user.role === 'Admin' || this.user.role === 'Teacher') {
        return this.puzzlesType
      } else {
        return this.puzzlesType.filter(p => p.type !== 'Practica0')
      }
    }
  },
  events: {
    updateBoards (classBoard) {
      this.classBoard = classBoard
    },
    mensaje (data) {
      // window.alert('mensaje' + JSON.stringify(data))
      this.recibeMensaje(data.men, true, true)
    }
  },
  methods: {
    recibeMensaje (men, bottom = false, toast = true) {
      // var idDiv = 'chatConvertGame'
      // var divScroll = document.getElementById(idDiv)
      // var atBottom = divScroll.scrollTop >= divScroll.scrollHeight - divScroll.clientHeight
      // window.alert(JSON.stringify(men))
      if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000)
        }
      }
    },
    isUserClub (club) {
      var ret = false
      var clubList = club.split(',')
      for (var i = 0; i < clubList.length; i++) {
        // window.alert(clubList[i])
        if (this.user.club === clubList[i]) {
          ret = true
          break
        }
      }
      return ret
    },
    selectItm (item) {
      this.item = item
      // window.alert(JSON.stringify(this.item))
    },
    nextPuzzle () {
      var post = this.puzzles.indexOf(this.item)
      if (post !== -1 && (post + 1) < this.puzzles.length) {
        this.selectItm(this.puzzles[post + 1])
      } else {
        if (((post + 1) >= this.puzzles.length) && ((this.puzzleTypesAvailable.indexOf(this.puzzleType) + 1) < this.puzzleTypesAvailable.length)) {
          this.selectPuzzleType(this.puzzleTypesAvailable[this.puzzleTypesAvailable.indexOf(this.puzzleType) + 1])
        } else {
          this.toast('<span>Ya no hay mas</span>', 2000)
        }
      }
    },
    selectPuzzleType (puzzle) {
      /* this.item = {
        num: 0
      }*/
      var self = this
      var timeLoading = setTimeout(function () {
        self.loading = 1
      }, 500)
      this.puzzleType = puzzle
      var parms = {
        // type: puzzle.type, club: this.user.club
        type: puzzle.type
      }
      return PuzzleService.get(this, parms).then(function (response) {
        const theD = JSON.parse(response)
        self.puzzles = theD
        // Supongamos que el club que deseas mantener se llama "clubDeseado"
        const clubDeseado = self.user.club
        // Filtrar el array para mantener solo los elementos que tienen el club deseado
        self.puzzles = self.puzzles.filter(puzzle => {
          // Divide la lista de clubs en el campo "club" por comas y verifica si contiene el club deseado
          const clubs = puzzle.club.split(',').map(c => c.trim()) // Divide la lista de clubs por comas
          return clubs.includes(clubDeseado) // Verifica si el club deseado está en la lista
        })
        setTimeout(function () {
          const id = localStorage.getItem('beginnerPracticeId')
          if (id) {
            const found = self.puzzles.find(p => p._id === id)
            if (found) {
              self.selectItm(found)
            } else if (self.puzzles.length > 0) {
              self.selectItm(self.puzzles[0])
            }
            localStorage.removeItem('beginnerPracticeId')
          } else if (self.puzzles.length > 0) {
            self.selectItm(self.puzzles[0])
          }
          Jquery('#listSomePuzzles').animate({
            'scrollTop': 0
          }, 'slow')
        }, 400)
        clearTimeout(timeLoading)
        self.loading = 0
      }, function (response) {
        self.error = response.data
        clearTimeout(timeLoading)
        self.loading = 0
      })
    },
    updateFenInit (orig, dest) {
      this.chess.move({
        from: orig,
        to: dest
      })
      // window.alert(groundInit.getFen())
      this.fenInit = groundInit.getFen()
    },
    updateFenFinish (orig, dest) {
      this.chess.move({
        from: orig,
        to: dest
      })
      // this.fenFinish = groundFinish.getFen()
    },
    addPuzzle (mode) {
      this.showFenPosition = false
      this.mode = mode
      if (!this.puzzleType.type) {
        this.toast('<span>Selecciona un tipo de puzzle</span>', 2000)
        return
      }
      this.tituloFen = this.titlefen
      // this.clubs = ''
      this.$broadcast('modal::open', 'modalCreatePuzzle')
      /* var options = {
        fen: this.fenInit,
        orientation: 'white',
        movable: {
          free: true,
          events: {
            after: this.updateFenInit
          }
        }
      }*/
      if (!this.puzzleType.type.startsWith('Practica')) {
        setTimeout(function () {
          // groundInit = Chessground(document.getElementById('puzzleGenerateFenInit'), options)
          var pgnBoardInit = 0
          if (document.getElementById('pgnMoves')) {
            document.getElementById('pgnMoves').textContent = ''
          }
          if (document.getElementById('pgnButtons')) {
            document.getElementById('pgnButtons').textContent = ''
          }
          /* if (document.getElementById('pgnHeader')) {
            document.getElementById('pgnHeader').textContent = ''
          } */
          var pos = 'start' // board.fen !== undefined ? board.fen : 'end'
          var start = 'start'
          // var pgnNew = this.pgn.split('"]').join('"]\n')
          // pgnNew = pgnNew.split('{}').join('')
          var headers = this.parse_pgn_header(this.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = headers['FEN']
          } else {
            // window.alert(board.fen + ' ' + start)
          }
          if (start === pos) {
            start = 0
          }
          // window.alert(this.fenInit)
          // window.alert(this.pgn)
          if (this.fenInit !== '' && this.fenInit !== undefined) {
            start = this.fenInit
          }
          try {
            // var winWidth = Math.min(window.innerWidth, window.outerWidth)
            pgnBoardInit = window.pgnEdit({inner: 'puzzleGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons'}, {pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: false, headers: true})
            groundInit = pgnBoardInit.board
            window.pgnBoardBase = pgnBoardInit.boardBase
            window.ground = pgnBoardInit.board
            var options = {
              animation: {
                enabled: true,
                duration: 600
              }
            }
            // window.alert(pgnBoard.boardBase.getPgn().write_pgn())
            // window.alert(JSON.stringify(pgnBoard.boardBase.getPgn().getMove(0)))
            window.ground.set(options)
            // window.alert(pgnBoardInit.chess)
          } catch (error) {
            // this.toast('<span>' + 'Error (AddPuzzle): ' + error + '</span>', 3000)
            console.error('<span>' + 'Error (AddPuzzle): ' + error + '</span>', 3000)
          }
          // window.alert(pgnBoardInit.boardBase.currentMove)
          /* setTimeout(function () {
            document.getElementById('pgnButtonslast').click()
          }, 100)*/
          // groundInit.set(options)
          /* if (this.puzzleType.position) {
            var optionsF = {
              fen: this.fenFinish,
              orientation: 'white',
              movable: {
                free: true,
                events: {
                  after: this.updateFenFinish
                }
              }
            }
            var pgnBoard = 0
            pgnBoard = window.pgnBoard({inner: 'puzzleGenerateFenFinish'}, {position: this.fenFinish, showCoords: false, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
            groundFinish = pgnBoard.board
            groundFinish.set(optionsF)
            // groundFinish = Chessground(document.getElementById('puzzleGenerateFenFinish'), optionsF)
          }*/
          if (document.getElementById('iFramePosition')) {
            var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
            if (searchinput) {
              // document.getElementById('iFramePosition').style.height = (document.documentElement.scrollHeight) + 'px'
              // window.alert(document.getElementById('iFramePosition').style.height)
              var idFEN = this.fenInit
              if (idFEN) {
                searchinput.value = idFEN
                searchinput.textContent = idFEN
              }
              searchinput.dispatchEvent(new window.Event('input'))
              searchinput.dispatchEvent(new window.Event('change'))
              searchinput.dispatchEvent(new window.Event('submit'))
            }
          }
        }.bind(this), 1000)
      } else {
        setTimeout(function () {
          if (document.getElementById('iFramePosition')) {
            var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
            if (searchinput) {
              // document.getElementById('iFramePosition').style.height = (document.documentElement.scrollHeight) + 'px'
              // window.alert(document.getElementById('iFramePosition').style.height)
              var idFEN = this.fenInit
              if (idFEN) {
                searchinput.value = idFEN
                searchinput.textContent = idFEN
              }
              searchinput.dispatchEvent(new window.Event('input'))
              searchinput.dispatchEvent(new window.Event('change'))
              searchinput.dispatchEvent(new window.Event('submit'))
              this.styles = Store.get('styleBoard',
                {
                  board: 0,
                  pieces: 0
                })
              document.getElementById('iFramePosition').contentWindow.setPieceTheme(this.stylesBoard['pieces'][this.styles['pieces']])
              document.getElementById('iFramePosition').contentWindow.setBoardTheme(this.stylesBoard['board'][this.styles['board']])
            }
          }
        }.bind(this), 1000)
      }
    },
    generateHeader (pgnFile, complete = true, onlyNames = false) {
      var retHeader = ''
      // var pgnInLines = pgnFile.split('"]').join('"]\n')
      var headers = this.parse_pgn_header(pgnFile)
      if (headers !== undefined && headers['Event'] !== undefined) {
        var appendHeader = function (result, headers, separator) {
          if (headers && headers.length > 0) {
            if (result.length > 0) {
              result += separator
            }
            result += headers
          }
          return result
        }
        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']] // , headers['ECO'], headers['Result']]
        if (complete) {
          retHeader = headers['White'] + ' vs ' + headers['Black']
          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']]
        }
        if (onlyNames) {
          retHeader = headers['White'] + ' (' + headers['WhiteElo'] + ')' + ' vs ' + headers['Black'] + ' (' + headers['BlackElo'] + ')'
          hh = []
        }
        if (hh.length > 1) {
          var rest = ''
          retHeader += ' ('
          hh.forEach(function (headers) {
            rest = appendHeader(rest, headers, ' | ')
          })
          retHeader += rest
          retHeader += ')'
        }
        // window.alert(retHeader)
      }
      // retHeader = decodeURIComponent(escape(retHeader))
      return retHeader
    },
    readTextFile (file, callback, encoding) {
      var reader = new window.FileReader()
      reader.addEventListener('load', function (e) {
        callback(this.result)
      })
      if (encoding) {
        reader.readAsText(file, encoding)
      } else {
        reader.readAsText(file)
      }
    },
    isListFiles () {
      var input = document.getElementById('files')
      if (input.files && input.files[0] && input.files[0].length > 0) {
        return true
      }
      return false
    },
    listFiles () {
      this.fileChosen()
    },
    hashCode (s) {
      var h = 0
      var l = s.length
      var i = 0
      if (l > 0) {
        while (i < l) {
          h = (h << 5) - h + s.charCodeAt(i++) | 0
        }
      }
      var hexString = h.toString(16)
      return hexString
    },
    deleteComment (pgn) {
      pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },
    cleanPGNContent (str) {
      return str.replace(/(\r?\n){2,}/g, '\n\n') // Mantener exactamente dos saltos entre partidas
        .replace(/\r?\n/g, (match, offset, string) => {
          const prevChar = string[offset - 1]
          const nextChar = string[offset + 1]
          // Si está entre partidas (dos saltos consecutivos), mantener el salto
          if (prevChar === '\n') {
            return match // No modificar, es parte de la separación entre partidas
          }
          // Si está dentro de los movimientos o comentarios
          if (prevChar === ']' || nextChar === '[') {
            return match // Mantener el salto de línea
          }
          return ' ' // Reemplazar con un espacio
        }).replace(/ {2,}/g, ' ') // Eliminar espacios dobles
    },
    prettyPgn (strParam) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      var str = strParam
      try {
        // Intentar decodificar la cadena como UTF-8
        str = Buffer.from(strParam, 'latin1').toString('utf8')
      } catch (e) {
        str = strParam
      }
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O') // .replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = this.cleanPGNContent(str)
      return str
    },
    parsePgnFiles (file, number) {
      this.pgnFiles = ''
      var newlineChar = '\r?\n'
      var filesObj = {}
      file = this.prettyPgn(file)
      // file = this.deleteComment(file)
      var lines = file.split(new RegExp(newlineChar))
      var pgntext = ''
      var state = 0 // 0 header, 1 moves
      var index = 0
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length > 0) {
          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
            if (state === 1) {
              index = index + 1
              var headers = this.parse_pgn_header(pgntext)
              var hashCode = this.hashCode(pgntext)
              var board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
              filesObj[index] = board
              // window.alert(JSON.stringify(filesObj[index]))
              pgntext = ''
            }
            state = 0
          } else {
            state = 1
          }
          if (state === 0) {
            pgntext += lines[i] + '\r\n'
          } else {
            pgntext += lines[i] + ' '
          }
        }
      }
      headers = this.parse_pgn_header(pgntext)
      hashCode = this.hashCode(pgntext)
      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
      index = index + 1
      filesObj[index] = board
      // window.alert(JSON.stringify(filesObj[index]))
      // filesObj[i] = pgntext
      this.pgnFiles = filesObj
      // this.$broadcast('modal::close', 'some ', 'modalCreatePuzzle')
      // this.$broadcast('modal::open', 'pgnFilesModal')
      return filesObj
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      // window.alert(header)
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    openPGN (pgnText) {
      // var output = document.getElementById('idTextAreaPGN')
      // var idFEN = document.getElementById('myFENValue')
      // output.value = pgnText
      // output.textContent = pgnText
      // window.alert(output.value)
      // idFEN.value = ''
      // idFEN.textContent = ''
      // idFEN.dispatchEvent(new window.Event('input'))
      var pgnAux = pgnText
      pgnAux = pgnAux.replace('0-0', 'O-O')
      pgnAux = pgnAux.replace('0-0-0', 'O-O-O')
      // pgnAux = pgnAux.replace(/\{( *)\}/gmu, '')
      // pgnAux = pgnAux.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      this.myPGNValue = pgnAux
      // output.dispatchEvent(new window.Event('change'))
      // this.$broadcast('modal::close', 'some', 'pgnFilesModal')
      // this.changePGNTextArea()
    },
    fileChosen () {
      var output = document.getElementById('idTextAreaPGN')
      var input = document.getElementById('files')
      var _self = this
      if (input.files && input.files[0]) {
        this.readTextFile(input.files[0],
          function (str) {
            if (output !== undefined) {
              output.value = ''
              output.dispatchEvent(new window.Event('change'))
            }
            _self.parsePgnFiles(str)
          }, 'ISO-8859-1'
        )
      }
    },
    changePGNTextArea () {
      var idTextArea = document.getElementById('idTextAreaPGN')
      if (idTextArea && idTextArea.value !== 'none') {
        var pgnAux = idTextArea.value
        pgnAux = pgnAux.replace('0-0', 'O-O')
        pgnAux = pgnAux.replace('0-0-0', 'O-O-O')
        // pgnAux = pgnAux.replace(/\{( *)\}/gmu, '')
        // pgnAux = pgnAux.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
        this.myPGNValue = pgnAux
        var headers = this.parse_pgn_header(idTextArea.value)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          this.myFENValue = headers['FEN']
          // window.alert(headers['FEN'])
        }
        // window.alert(idTextArea.value)
        idTextArea.value = ''
      }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    setFenPosition () {
      if (document.getElementById('iFramePosition')) {
        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
        if (searchinput !== undefined && searchinput !== null) {
          // window.alert(searchinput.value)
          // var idFEN = document.getElementById('myFENValue')
          var txtPgn = ''
          txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]'
          // var idTextArea = document.getElementById('idTextAreaPGN')
          // idTextArea.value = idFEN.value
          this.fenInit = searchinput.value
          this.fenFinish = searchinput.value
          this.pgn = txtPgn
          this.myPGNValue = txtPgn
          setTimeout(function () {
            document.getElementById('pgnButtonsfirst').click()
          }, 2000)
          // idFEN.value = searchinput.value
          // idFEN.textContent = searchinput.value
          // idFEN.dispatchEvent(new window.Event('input'))
          // idTextArea.dispatchEvent(new window.Event('change'))
          // window.alert(txtPgn)
          // this.$broadcast('modal::close', 'some', 'setFen')
        }
      }
    },
    listaDeClubs (tipo) {
      var parms = {
        type: tipo
      }
      var _self = this
      _self.listaclubs = []
      ClubService.get(_self, parms).then(function (response) {
        JSON.parse(response).forEach(function (element) {
          _self.listaclubs.push(element)
        })
      }, function (response) {
        this.error = response.data
      })
    },
    subirPuzzle (id) {
      PuzzleService.incpos(this, id).then(function (response) {
        this.selectPuzzleType(this.puzzleType)
      }, function (response) {
      })
    },
    bajarPuzzle (id) {
      PuzzleService.decpos(this, id).then(function (response) {
        this.selectPuzzleType(this.puzzleType)
      }, function (response) {
      })
    },
    putPosPuzzle (idParam, posParam) {
      var _self = this
      // window.alert(JSON.stringify(params))
      PuzzleService.putpuzzle(_self, {
        id: idParam,
        pos: posParam
      }).then(function (response) {
        _self.selectPuzzleType(_self.puzzleType)
      }, function (response) {
        self.error = response.data
      })
    },
    addClubToGeneralPuzzles (clubParam) {
      var _self = this
      var nameClub = 'General'
      Swal.fire({
        title: '¿Nombre del club para importar?',
        input: 'text',
        showCancelButton: true,
        inputPlaceholder: 'General',
        confirmButtonText: 'Aceptar'
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          nameClub = result.value
          if (nameClub === '') {
            nameClub = 'General'
          }
          // Puedes usar `this` dentro de Vue 1 con una variable auxiliar si lo necesitas
          window.swal('¿Quiere importar todos los ejercicios de ' + nameClub + '?', {
            buttons: {
              si: {text: 'Sí', value: 's'},
              no: {text: 'No', value: 'n'}
            }
          }).then(function (resultParam) {
            // window.alert(resultParam)
            if (resultParam === 's') {
              // Llamada al servicio para añadir el club al puzzle
              PuzzleService.addclubtogeneralpuzzles(_self, {
                club: clubParam, // El nuevo club a añadir
                clubDestino: nameClub
              }).then(function (response) {
                // Si la respuesta es correcta, ejecutar la lógica
                _self.selectPuzzleType(_self.puzzleType)
                window.swal('Importación correcta')
              }, function (response) {
                // Manejo de errores
                _self.error = response.data
                window.swal(_self.error)
              })
            }
          })
        }
      })
    },
    isSelected (clubName) {
      var ret = false
      this.clubs = this.clubs.replace(' ,', ',')
      this.clubs = this.clubs.replace(', ', ',')
      var clubList = this.clubs.split(',')
      for (var i = 0; i < clubList.length; i++) {
        if (clubName === clubList[i]) {
          // window.alert(clubList[i])
          ret = true
          break
          // return true
        }
      }
      return ret
    },
    handleSelectChange (event) {
      // Accede a las opciones seleccionadas
      // const selectedValue = event.target.value
      const selectedValues = Array.from(event.target.selectedOptions).map(option => option.value)
      // const selectedOptions = Jquery('#opciones').val()
      var clubActual = ''
      var count = selectedValues.length
      var num = 0
      selectedValues.forEach(function (element) {
        clubActual += element
        num++
        if (num < count) {
          clubActual += ','
        }
      })
      this.clubActual = clubActual
    },
    createPuzzle (action) {
      // window.alert('Crear puzzle: ' + action)
      if (action) {
        this.clubs = this.clubs.replace(' ,', ',')
        this.clubs = this.clubs.replace(', ', ',')
        // var clubList = this.clubs.split(',')
        // for (var i = 0; i < clubList.length; i++) {
        // if (this.puzzleType.startsWith('Practica')) {
        this.setFenPosition()
        // window.alert(clubList[i])
        // validar que no existe uno similar en db
        var newPuzzle = {
          type: this.puzzleType.type,
          createby: UserService.getUser().username,
          club: this.clubs, // clubList[i], // UserService.getUser().club,
          feninit: this.fenInit,
          fenfinish: this.fenFinish,
          startPlay: this.startPlay,
          pgn: this.pgn,
          nummoves: this.numMoves, // this.puzzleType.type === 'MateIn' ? this.numMoves : this.puzzleType.numMoves,
          timemove: this.timeMove, // this.puzzleType.type === 'MateIn' ? this.numMoves : this.puzzleType.numMoves,
          titlefen: this.tituloFen,
          mode: this.mode
        }
        // window.alert(JSON.stringify(newPuzzle))
        PuzzleService.add(this, newPuzzle).then(function (response) {
          this.toast('<span>Creado correctamente</span>', 3000)
          // actualizar listado
          // this.selectPuzzleType(this.puzzleType)
          // seleccionar actual
          if (this.mode === 'add') {
            this.selectItm(this.item)
            // this.nextPuzzle()
          } else {
            // console.log('selecciona otra vez para ver los cambios')
          }
          // actualizar listado
          this.$broadcast('modal::close', 'some', 'modalCreatePuzzle')
          // window.alert(JSON.stringify(response.data))
          this.selectPuzzleType(this.puzzleType)
        }, function (response) {
          this.error = response.data
          // console.log(response.data)
        })
      // }
      } else {
        this.$broadcast('modal::close', 'some', 'modalCreatePuzzle')
      }
    },
    resizeBoard () {
      if (document.getElementById('middle') && document.getElementById('puzzleBoard')) {
        var Width = document.getElementById('middle').clientWidth
        // Width = Width > window.innerWidth ? window.innerWidth - 205 : Width // document.getElementById('middle').clientWidth
        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
          Width = Width - 20
        }
        if (document.getElementById('puzzleBoard')) {
          document.getElementById('puzzleBoard').style.height = Width + 'px'
          document.getElementById('puzzleBoard').style.width = Width + 'px'
        }
        // window.alert(Width)
        // Jquery('#pgnBoard').load(window.location.href + '#pgnBoard')
        // this.toast('<span>Width: ' + Width + '</span>', 2000, 'rounded')
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
    },
    onResize (event) {
      this.resizeBoard()
    },
    editPuzzle () {
      this.showFenPosition = false
      if (this.item) {
        this.pgn = this.item.pgn
        this.fenInit = this.item.feninit
        this.numMoves = this.item.nummoves
        this.timeMove = this.item.timemove
        this.timeFen = this.item.timefen
        this.titlefen = this.item.titlefen
        this.clubs = this.item.club
        // window.alert(this.clubs)
        this.addPuzzle(this.item._id)
        /* setTimeout(function () {
          this.fenInit = this.item.feninit
          if (this.item.fenfinish) {
            this.fenFinish = this.item.fenfinish
          }
        }.bind(this), 1000)*/
      }
    },
    delPuzzle () {
      var _self = this
      window.swal('¿Está seguro de eliminar el ejercicio?', {
        buttons: {
          si: {text: 'Sí', value: 's'},
          no: {text: 'No', value: 'n'}
        }
      }).then(function (resultParam) {
        // window.alert(resultParam)
        if (resultParam === 's') {
          PuzzleService.del(_self, _self.item._id).then(function (response) {
            _self.selectPuzzleType(_self.puzzleType)
          }, function (response) {
            _self.error = response.data
          })
        }
      })
      /* if (window.confirm('Seguro de eliminar')) {
        PuzzleService.del(this, this.item._id).then(function (response) {
          this.selectPuzzleType(this.puzzleType)
        }, function (response) {
          this.error = response.data
        })
      }*/
    }
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('puzzles.title')
    this.resizeBoard()
  },
  created () {
    this.listaDeClubs('Clubs')
    window.addEventListener('resize', this.onResize)
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    // window.alert(this.classBoard)
    this.resizeBoard()
    if (true) {
      const typeObj = this.puzzleTypesAvailable.find(p => p.type === ('Practica'))
      if (typeObj) {
        this.selectPuzzleType(typeObj).then(() => {
          const id = localStorage.getItem('beginnerPracticeId')
          const found = this.puzzles.find(p => p._id === id)
          if (found) {
            this.selectItm(found)
          }
          localStorage.removeItem('beginnerPracticeId')
        })
      }
    } else {
      this.nextPuzzle()
    }
  },
  watch: {
    clubActual (val, oldVal) {
      this.clubs = val
    },
    myFENValue (val, oldVal) {
      this.fenInit = val
      // window.alert(val)
    },
    myPGNValue (val, oldVal) {
      this.pgn = val
      // window.alert(this.pgn)
      setTimeout(function () {
        var pgnBoardInit = 0
        if (document.getElementById('pgnMoves')) {
          document.getElementById('pgnMoves').textContent = ''
        }
        if (document.getElementById('pgnButtons')) {
          document.getElementById('pgnButtons').textContent = ''
        }
        /* if (document.getElementById('pgnHeader')) {
          document.getElementById('pgnHeader').textContent = ''
        } */
        var pos = 'start' // board.fen !== undefined ? board.fen : 'end'
        var start = 'start'
        var pgnNew = this.pgn.split('"]').join('"]\n')
        // pgnNew = pgnNew.split('{}').join('')
        var headers = this.parse_pgn_header(pgnNew)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = headers['FEN']
        } else {
          // window.alert(board.fen + ' ' + start)
        }
        if (start === pos) {
          start = 0
        }
        if (this.fenInit !== '' && this.fenInit !== undefined) {
          start = this.fenInit
        }
        try {
          // var winWidth = Math.min(window.innerWidth, window.outerWidth)
          pgnBoardInit = window.pgnEdit({inner: 'puzzleGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons'}, {pgn: this.pgn, fen: pos, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: false, headers: true})
          groundInit = pgnBoardInit.board
          window.pgnBoardBase = pgnBoardInit.boardBase
          window.ground = pgnBoardInit.board
          var options = {
            orientation: this.orientation,
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            animation: {
              enabled: true,
              duration: 600
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          }
          // window.alert(pgnBoard.boardBase.getPgn().write_pgn())
          // window.alert(JSON.stringify(pgnBoard.boardBase.getPgn().getMove(0)))
          this.ground.set(options)
          // window.alert(pgnBoardInit.chess)
          /* setTimeout(function () {
            document.getElementById('pgnButtonslast').click()
          }, 100)*/
          const comments = document.querySelectorAll('.afterComment')
          comments.forEach((comment) => {
            // Verifica si el texto del comentario contiene el emoji 🎥
            const textResource = comment.textContent.toLowerCase()
            if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
              // Añade la clase .highlight-move al elemento padre con clase .move
              comment.closest('.move').classList.add('highlight-move')
            }
          })
        } catch (error) {
          // this.toast('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000)
          console.error('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000)
        }
      }.bind(this), 50)
    },
    fenInit (newVal, oldVal) {
      if (newVal === '') {
        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      }
      /* groundInit.set({
        fen: newVal
      })*/
    },
    fenFinish (newVal, oldVal) {
      if (newVal === '') {
        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      }
      /* groundFinish.set({
        fen: newVal
      }) */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/libs/simplechessboard.min.css';
h1 {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// index.vue?ff26cd70